import { RANGE_TYPE } from '../constants';
import { parseNumberPrecisionByDoteCount } from '../../../../core/helpers/parseNumberByPrecision';

export const getRangeNumberCountFromMultiplier = {
  [RANGE_TYPE.Under]: (odd, rtp) => {
    const role = (rtp * 100) / odd;
    return parseNumberPrecisionByDoteCount(1, role.toFixed(2), 2);
  },
  [RANGE_TYPE.Over]: (odd, rtp) => {
    const role = 100 - (rtp * 100) / odd;
    return parseNumberPrecisionByDoteCount(1, role.toFixed(2), 2);
  },
};

export const getOddByBetType = {
  [RANGE_TYPE.Under]: (number, rtp) => {
    return (rtp * 100) / number;
  },
  [RANGE_TYPE.Over]: (number, rtp) => {
    return (rtp * 100) / parseNumberPrecisionByDoteCount(1, 100 - number, 4);
  },
};
export function detectLegendActivity(rangeValue, legendValue, rangeType) {
  if (rangeType === RANGE_TYPE.Under) {
    return rangeValue >= legendValue ? 'active' : '';
  }
  return rangeValue <= legendValue ? 'active' : '';
}
export const diceRangeChecker = (firstDiceRange, dicesValues) => {
  // const rangeValueForView = () => {
  //   if (rangeValue > DICE_RANGE_LIMIT_OPTIONS.max) {
  //     return DICE_RANGE_LIMIT_OPTIONS.min;
  //   }
  //   if (rangeValue < DICE_RANGE_LIMIT_OPTIONS.min) {
  //     return DICE_RANGE_LIMIT_OPTIONS.min;
  //   }
  //   return rangeValue;
  // };
  if (firstDiceRange) {
    return dicesValues?.firstDice.rangeValue;
  }
  return dicesValues?.secondDice.rangeValue;
};
